<!--
this component is intended to hold other components, and pass options down from its parent into its children
it's not intended to do any other processing of options
-->

<template>
  <div>
    <b-card class="rounded-0 flush-top-sides" bg-variant="lighter">
      <div class="d-flex">
        <slot name="settings"></slot>
      </div>
    </b-card>
    <b-tabs class="my-4" nav-wrapper-class="card-tabs" @input="onTabChange">
      <b-card no-body class="tabs-card">
        <b-tab no-body
               v-for="tab in tabList"
               :title="tab.tabName"
               :key="tab.field"
               :disabled="tab.disabled">
          <template v-if="tab.loaded">
            <keep-alive v-if="tab.component">
              <component :is="tab.component" :options="options" v-bind="tab"></component>
            </keep-alive>
            <div v-else>
              Not yet implemented
            </div>
          </template>
        </b-tab>
      </b-card>
    </b-tabs>
  </div>
</template>

<script>
    import auth from '@/auth'

    export default {
        props: {
            tabs: {required: true, type: Array},
            options: {required: true, type: Object},
        },
        data() {
            return {
                currentTab: 0,
                perPage: 10,
                tabList: [...this.tabs]
            }
        },
        created() {
            this.initTabs()
        },
        methods: {
            onTabChange(tabNum) {
                this.currentTab = tabNum
                let tab = this.tabList[tabNum]
                this.$set(tab, 'loaded', true)
            },
            initTabs() {
                for (let tab of this.tabs) {
                    this.$set(tab, 'loaded', false)
                }
            }
        },
        watch: {
            options() {
                this.initTabs()
                let currentTab = this.tabs[this.currentTab]
                currentTab.loaded = true
            },
            tabs() {
                this.initTabs()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/components/ReportTabs.vue